module.exports = __webpack_public_path__ + "img/intensity-indicator-intermediate.991cb534.svg";